import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import Column from '../../shared/ui/Column';
import FilterBtn from '../../shared/ui/FilterBtn';
import HousesList from '../../controllers/HousesList';
import HousesListFilter from '../../controllers/HousesListFilter';
import SelectCity from '../../controllers/SelectCity';
import { actionCreators, selectors, sliceKeys } from '../../model';
import ModelSearch from '../../controllers/ModelSearch';

const { selectCurrentId: selectCompanyId } = selectors[sliceKeys.companies];
const { selectCurrentId: selectCityId } = selectors[sliceKeys.cities];
const { selectSearch: selectHouseSearch, selectHasFilter } =
  selectors[sliceKeys.houses];
const { searchChanged: houseSearchChange } = actionCreators[sliceKeys.houses];

const HousesCol = () => (
  <Column title="Дома">
    <EmptyWrapper selector={selectCompanyId} description="Выберите компанию">
      <SelectCity>
        <EmptyWrapper selector={selectCityId} description="Выберите город">
          <HousesList>
            <div className="colFilterWrap">
              <ModelSearch
                selector={selectHouseSearch}
                createAction={houseSearchChange}
              />
              <FilterBtnBlock />
            </div>
          </HousesList>
        </EmptyWrapper>
      </SelectCity>
    </EmptyWrapper>
  </Column>
);

export default HousesCol;

function EmptyWrapper({ selector, description, children }) {
  const data = useSelector(selector);

  if (!data) {
    return (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
    );
  }

  return children;
}

function FilterBtnBlock() {
  const hasFilter = useSelector(selectHasFilter);

  return <FilterBtn renderContent={renderFilter} isActive={hasFilter} />;
}

function renderFilter({ onClose }) {
  return <HousesListFilter onClose={onClose} />;
}
